<div class="form-group row">
    <ng-content select=".label"></ng-content>
    <div class="col-sm-7">
        <ng-content select=".input"></ng-content>
    </div>
</div>
